module.exports = "pegasus/assets/theme3/medium/2.jpg";